// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'folder-nested';

export const Component = () => (
  <path d='M10.86 12.74h10.776c.239 0 .479-.097.719-.288a.946.946 0 0 0 .287-.67V4.883a.946.946 0 0 0-.287-.67c-.24-.191-.48-.287-.72-.287h-4.884l-.719-1.437c-.191-.335-.479-.527-.862-.527h-4.31a.977.977 0 0 0-.719.288.943.943 0 0 0-.287.67v3.927H3.005V.478C3.005.145 2.862 0 2.527 0 2.19 0 2 .144 2 .479V18.63c0 .24.096.48.335.67.192.24.431.336.67.336h6.849v3.88c0 .287.096.526.287.718a.973.973 0 0 0 .72.288h10.775c.239 0 .479-.096.719-.288a.976.976 0 0 0 .287-.718v-6.849a.946.946 0 0 0-.287-.67c-.24-.192-.48-.288-.72-.288h-4.884l-.719-1.436c-.191-.335-.479-.527-.862-.527h-4.31a.977.977 0 0 0-.719.288.943.943 0 0 0-.287.67v3.927H3.005V7.855h6.849v3.928c0 .239.096.479.287.67a.976.976 0 0 0 .72.288v-.002Zm0-.959v-8.86h4.31l.958 1.963h5.508v6.897H10.86Zm0 11.734v-8.813h4.31l.958 1.964h5.508v6.848H10.86Z' />
);

export const viewBox = '0 0 25 25';
